import { Component, Vue } from 'vue-property-decorator';
import SideNavigation from '@/components/SideNavigation/SideNavigation';
import { performances } from '@/views/PerformanceShop/performanceList';

@Component<PerformanceDetail>({
  components: {
    SideNavigation,
  },
})
export default class PerformanceDetail extends Vue {
  protected performanceInformation: any = [{
    title: 'Sound recording',
    items: [{
      title: 'Title',
      value: 'Zomerhits_Juli.mp4'
    }, {
      title: 'Version title',
      value: 'Zomerhits_Juli.mp4'
    }, {
      title: 'Alternate titles',
      value: 'Alternate'
    }, {
      title: 'Labels',
      value: 'labels'
    }, {
      title: 'Primary Artist',
      value: 'artist name'
    }, {
      title: 'ISRC',
      value: '45dsf45dsf45'
    }, {
      title: 'Additional artists',
      value: 'Additional'
    }, {
      title: 'Released',
      value: '07-17-2017'
    }, {
      title: 'Duration',
      value: '04:17 minutes'
    }, {
      title: 'Territory',
      value: 'Berlin, Germany'
    }, {
      title: 'Edited',
      value: 'Edited'
    }, {
      title: 'Album',
      value: 'album name'
    }]
  }, {
    title: 'Musical Works[s]',
    items: [{
      title: 'File name',
      value: 'Zomerhits_Juli.mp4'
    }, {
      title: 'Name',
      value: 'Zomerhits_Juli.mp4'
    }]
  }, {
    title: 'Recording Artists',
    items: [{
      title: 'File name',
      value: 'Zomerhits_Juli.mp4'
    }, {
      title: 'Name',
      value: 'Zomerhits_Juli.mp4'
    }]
  }];
  protected currentPerformance: Performance =  {
    playTime: '',
    title: '',
    artist: '',
    location: '',
    image: '',
    uuid: '',
  };
  public mounted() {
    this.initialize();
  }

  protected initialize() {
    this.setCurrentPerformance();
  }

  protected setCurrentPerformance() {
    performances.forEach((performance: Performance) => {
      if (this.$route.params.id === performance.uuid) this.currentPerformance = performance;
    });
  }
}

interface Performance {
  playTime: string;
  title: string;
  artist: string;
  location: string;
  image: string;
  uuid: string;
}
